"use client";

// src/use-typography.ts
import { useDOMRef } from "@kirvanobr/react-utils";
import { typography } from "@kirvanobr/theme";
import { useCallback, useMemo } from "react";
import { clsx } from "@kirvanobr/shared-utils";
function useTypography(originalProps) {
  const {
    ref,
    as,
    className,
    classNames,
    variant,
    size,
    weight,
    color,
    ...otherProps
  } = originalProps;
  let Component;
  switch (variant) {
    case "title":
      switch (size) {
        case "t1":
          Component = as || "h1";
          break;
        case "t2":
          Component = as || "h2";
          break;
        case "t3":
          Component = as || "h2";
          break;
        case "t4":
          Component = as || "h4";
          break;
        case "t5":
          Component = as || "h5";
          break;
        case "t6":
          Component = as || "h6";
          break;
        case "t7":
          Component = as || "h6";
          break;
        default:
          Component = as || "h6";
          break;
      }
      break;
    case "body":
    case "subtitle":
      Component = as || "p";
      break;
    case "assistant":
      Component = as || "span";
      break;
    default:
      Component = as || "p";
      break;
  }
  const domRef = useDOMRef(ref);
  const slots = useMemo(
    () => typography({
      variant,
      size,
      weight,
      color,
      className
    }),
    [variant, size, weight, color, className]
  );
  const baseStyles = clsx(classNames == null ? void 0 : classNames.base, className);
  const getBaseProps = useCallback(
    (props = {}) => {
      return {
        ...props,
        ...otherProps,
        ref: domRef,
        className: slots.base({ class: baseStyles })
      };
    },
    [otherProps, slots.base, classNames == null ? void 0 : classNames.base]
  );
  return { Component, getBaseProps, variant };
}

export {
  useTypography
};
